var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 17.3327C4.40499 17.3327 0.666656 13.5952 0.666656 8.99935C0.666656 4.40518 4.40499 0.666016 8.99999 0.666016C13.595 0.666016 17.3333 4.40435 17.3333 8.99935C17.3333 13.5952 13.595 17.3327 8.99999 17.3327ZM8.99999 2.33268C5.32416 2.33268 2.33332 5.32352 2.33332 8.99935C2.33332 12.6752 5.32416 15.666 8.99999 15.666C12.6758 15.666 15.6667 12.6752 15.6667 8.99935C15.6667 5.32352 12.6758 2.33268 8.99999 2.33268Z",
    fill: "#80919F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 11.4987V8.16536C9.83333 7.70536 9.46083 7.33203 9 7.33203H7.33333V8.9987H8.16667V11.4987H6.5V13.1654H11.5V11.4987H9.83333Z",
    fill: "#80919F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 6.70833C9.57528 6.70833 10.0416 6.24196 10.0416 5.66667C10.0416 5.09137 9.57528 4.625 8.99998 4.625C8.42468 4.625 7.95831 5.09137 7.95831 5.66667C7.95831 6.24196 8.42468 6.70833 8.99998 6.70833Z",
    fill: "#80919F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.88fa9b96bde9d8c9fadafff400042d1f.svg";
export { ForwardRef as ReactComponent };